import React, { useEffect } from 'react';
import { ADMIN_SECTIONS, adminExitPath, rememberAdminSection } from '../utils/adminNav';
import { DOZEN_APP, WORD_APP } from '../apps';
import AppShell from './AppShell';
import GameSwitch from './GameSwitch';

/** Admin chrome: game switcher on top, back arrow returns to where admin was opened from. */
function AdminShell({ section, children }) {
  useEffect(() => {
    rememberAdminSection(section);
  }, [section]);

  const app = section === 'dozen' ? DOZEN_APP : WORD_APP;

  return (
    <AppShell app={app} title="Админ" showBack backTo={adminExitPath()} hideTabs adminMode>
      <GameSwitch sections={ADMIN_SECTIONS} />
      {children}
    </AppShell>
  );
}

export default AdminShell;
